var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.show && _vm.coords
      ? _c(
          "div",
          {
            ref: "wrapper",
            class: [
              "visual-tooltip",
              { "visual-tooltip_with_angle": _vm.angle },
              "is-" + _vm.directionPretty,
              _vm.data && _vm.data.modify
                ? "visual-tooltip_is_" + _vm.data.modify
                : "",
            ],
            style: { top: _vm.y + "px", left: _vm.x + "px" },
          },
          [
            [
              _vm.component
                ? _c(_vm.component, {
                    tag: "component",
                    attrs: { tooltip: _vm.data.tooltip },
                  })
                : _vm._e(),
            ],
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }